import { useMemo } from "react";

import { useBrand } from "./useBrand";
import { useCurrentAccount } from "./useCurrentAccount";

export const useMarketplaceLink = () => {
  const { quality } = useCurrentAccount();
  const { customerPortal } = useBrand();

  const marketplaceLink = useMemo(() => {
    return customerPortal.marketplace?.find((marketplace) => marketplace.quality === quality)?.url;
  }, [customerPortal.marketplace, quality]);

  return marketplaceLink;
};
